import { getCookie } from '../../helpers/cookieMetods';
import type {
  NewsPost,
  NewsErrorEntry,
  NewsTagMenuItem,
  NewsCountResponse,
} from '../types/news';
import { apiUrl, parseJsonOrThrow } from './http';

export interface GetNewsListParams {
  userID?: string;
  fromNumber?: number;
  limitNumber?: number;
  filterType?: string;
  all?: number;
  categoryID?: number;
  tagsStatus?: boolean;
  qt?: boolean;
  edit?: number;
}

export const getNewsList = ({
  userID,
  fromNumber,
  limitNumber,
  filterType,
  all,
  categoryID = 1,
  tagsStatus,
  qt = false,
  edit,
}: GetNewsListParams): Promise<
  NewsPost[] | NewsErrorEntry | NewsCountResponse
> => {
  const token = getCookie('_form_token');
  const currentBody: Record<string, unknown> = {
    userID,
    start: fromNumber,
    limit: limitNumber,
    categoryID,
    all,
    token,
  };
  if (filterType === 'Популярне') currentBody.order = 'views';
  if (filterType === 'Сьогодні') currentBody.istoday = 'yes';
  if (filterType === 'Не переглянуті') currentBody.isview = 'no';
  if (tagsStatus) currentBody.tagNAME = filterType;
  if (qt) currentBody.qt = 'only';
  if (edit) currentBody.edit = edit;

  return fetch(apiUrl('/php/newsout.php'), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(currentBody),
  }).then((response) =>
    parseJsonOrThrow<NewsPost[] | NewsErrorEntry | NewsCountResponse>(response)
  );
};

export const getTagsList = (): Promise<NewsTagMenuItem[]> => {
  const token = getCookie('_form_token');
  return fetch(apiUrl('/php/out-tagmenu.php'), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ token }),
  }).then((response) => parseJsonOrThrow<NewsTagMenuItem[]>(response));
};

export const getAllTagsList = (): Promise<string[]> => {
  return fetch(apiUrl('/php/select-tags.php'), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ token: getCookie('_form_token') }),
  }).then((response) => parseJsonOrThrow<string[]>(response));
};

export const deleteTag = (
  id: string | number
): Promise<{ message?: string }> => {
  const token = getCookie('_form_token');
  return fetch(apiUrl('/php/delete-tagmenu.php'), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ token, tag_id: id }),
  }).then((response) => parseJsonOrThrow<{ message?: string }>(response));
};

export const deleteTagId = (
  tag_name: string
): Promise<{ message?: string }> => {
  const token = getCookie('_form_token');
  return fetch(apiUrl('/php/delete-tag.php'), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ token, tag_name }),
  }).then((response) => parseJsonOrThrow<{ message?: string }>(response));
};

export const addTag = (name: string): Promise<{ message?: string }> => {
  const token = getCookie('_form_token');
  return fetch(apiUrl('/php/add-tagmenu.php'), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ token, name }),
  }).then((response) => parseJsonOrThrow<{ message?: string }>(response));
};
